<template>
  <div class="d-none">
    <b-modal v-model="showModal" centered header-class="custom-modal-header" footer-class="custom-modal-footer">
    <template #modal-header>
      <p class="text-header">{{ msg }}</p>
    </template>
      <div class="text-center p-3">
        <p class="mb-0 f-18">{{text}}</p>
      </div>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-between">
          <button
            class="cancel-button"
            @click="hide"
          >
            {{btnCancel}}
          </button>
          <b-button :variant="colorBtnConfirm" @click="$emit('confirm')">{{btnConfirm}}</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    msg: {
      required: true,
      type: String
    },
    text: {
      required: true,
      type: String
    },
    btnConfirm: {
      required: true,
      type: String
    },
    colorBtnConfirm: {
      required: false,
      type: String
    },
    btnCancel: {
      required: true,
      type: String
    },
    colorBtnCancel: {
      required: false,
      type: String
    }
  },
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    }
  }
};
</script>
